// src/components/features/analysis/CodePreviewModal.jsx
import React from 'react';
import {
  CodeModal,
  CodeModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  CodePreview
} from '../../../styles/AnalysisStyles';

const CodePreviewModal = ({ selectedCode, onClose }) => {
  if (!selectedCode) return null;

  return (
    <CodeModal onClick={onClose}>
      <CodeModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Code Preview</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <CodePreview>{selectedCode}</CodePreview>
        </ModalBody>
      </CodeModalContent>
    </CodeModal>
  );
};

export default CodePreviewModal;